import React, { useEffect, useState, useContext } from "react";
import Table from "@mui/material/Table";
import {
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    TableFooter,
    TablePagination,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { DonationContext } from "./DonationProvider";
import PropTypes from "prop-types";

const DonationTable = ({ title }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const { appId } = useContext(DonationContext);

    if (!appId) {
        throw new Error("Donation Provider component required!");
    }

    useEffect(() => {
        fetch(`${process.env.API_URL}/donations/${appId}`)
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                setData(data.data);
            });
    }, []);

    // Pagination Logic
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    if (loading) {
        return <CircularProgress />;
    }

    return (
        <div className="ourpay-donation-table">
            {title && <h2>{title}</h2>}
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Id</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data
                        .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.name}</TableCell>
                                <TableCell>{row.amount}</TableCell>
                            </TableRow>
                        ))}
                </TableBody>
                <TableFooter>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </TableFooter>
            </Table>
        </div>
    );
};
DonationTable.propTypes = {
    title: PropTypes.string,
};

export default DonationTable;
